import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Placement } from '@popperjs/core';
import { IconSizesEnum, IIcon } from '../icon/icon.component';

@Component({
  selector: 'i2g-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuComponent {
  @Input() placement: Placement = 'bottom-end';

  contextMenuIcon: IIcon = {
    name: 'context-menu',
    size: IconSizesEnum.custom,
  };

  constructor() {}
}
